/*
 * @Author: wp
 * @Date: 2023-01-06 15:31:52
 * @Descripttion:
 */
import Vue from 'vue'
export default new Vue()
